import { useContext, useEffect, useState } from 'react'
import CourseClassHeaderNavigation from '../../components/CourseClassHeaderNavigation/CourseClassHeaderNavigation'
import OwnCoursesList from '../../features/OwnCourses/OwnCoursesList/OwnCoursesList'
import SpecialtiesBanner from '../../features/OwnCourses/SpecialtiesBanner/SpecialtiesBanner'
import MainLayout from '../../layouts/MainLayout/MainLayout'
import './OwnCourses.css'
import AuthContext from '../../contexts/AuthContext'
import axios from 'axios'
import showNotification from '../../utils/showNotification'
import { ERROR_HANDLER } from '../../utils/error-handler'
import OwnCoursesGridGroup from '../../features/OwnCourses/OwnCoursesGridGroup/OwnCoursesGridGroup'

export default function OwnCourses() {


   return (
      <MainLayout>
         <section className='OwnCourses-container'>
            <SpecialtiesBanner />

            <Subscription/>

            <CourseClassHeaderNavigation noButton title='Mis cursos' />

            <OwnCoursesList />

         </section>
      </MainLayout>
   )
}

const Subscription = () => {
   const { authToken } = useContext(AuthContext)
   const [state, setState] = useState({ isLoading: false, error: "", data: null })

   useEffect(() => {
      const getOwnCourses = async () => {

         try {
            const url = `${process.env.REACT_APP_BACKEND_SERVER}campus/users/courses?subscriptions=true`
            const { data } = await axios.get(url, {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${authToken}`
               }
            })

            setState(prevState => ({ ...prevState, data }))

         } catch (error) {
            showNotification({
               color: "red",
               status: "error",
               title: "Ha ocurrido un problema al cargar todos tus cursos.",
               message: `Detalle: ${ERROR_HANDLER[error.request.status] || ERROR_HANDLER.defaultError}`,
               autoClose: 12000
            });
            setState(prevState => ({ ...prevState, error: 'Lo siento, hemos tenido un error al intentar recuperar todos los cursos a los que estas suscripto. Intenta nuevamente.' }))
         } finally {
            setState(prevState => ({ ...prevState, isLoading: false }))
         }
      }

      getOwnCourses()
   }, [authToken])

   return (
      <>
      <CourseClassHeaderNavigation noButton title='Comunidad' />
      {state.data && <OwnCoursesGridGroup cardsToMap={state.data} />}
      </>
   )
}